import { AdsterraAd } from '@/components/AdsterraAd';
import { AdsterraBannerLarge } from '@/components/AdsterraBannerLarge';
import { AdsterraMediumRect } from '@/components/AdsterraMediumRect';

type ResponsiveAdBannerProps = {
  variant?: 'stacked' | 'single';
};

export const ResponsiveAdBanner = ({ variant = 'single' }: ResponsiveAdBannerProps) => {
  if (variant === 'stacked') {
    // Shows all ads that fit the current screen
    return (
      <div className="space-y-3">
        {/* Mobile: 320x50 - always visible on mobile, hidden on larger */}
        <div className="flex justify-center lg:hidden">
          <AdsterraAd />
        </div>
        
        {/* Tablet/Desktop: 728x90 - hidden on mobile, visible on md+ */}
        <div className="hidden md:flex justify-center">
          <AdsterraBannerLarge />
        </div>
        
        {/* Desktop only: 300x250 - only on large screens */}
        <div className="hidden lg:flex justify-center">
          <AdsterraMediumRect />
        </div>
      </div>
    );
  }

  // Single variant: shows one ad based on screen size
  return (
    <div className="flex justify-center">
      {/* Mobile: 320x50 */}
      <div className="block md:hidden">
        <AdsterraAd />
      </div>
      
      {/* Tablet: 728x90 */}
      <div className="hidden md:block lg:hidden">
        <AdsterraBannerLarge />
      </div>
      
      {/* Desktop: 300x250 */}
      <div className="hidden lg:block">
        <AdsterraMediumRect />
      </div>
    </div>
  );
};
